import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";

import Typography from "../../../ui/widgets/typography";
import { ProductContext } from "../../../context/product-context/productContext";
import { ScdAccordion } from "../../../ui/widgets/accordion";
import { ScdAccordionSummary } from "../../../ui/widgets/accordion/summary";
import { ScdAccordionDetails } from "../../../ui/widgets/accordion/details";

export default function DetailsSwisscard(): React.JSX.Element {
  const { selectedProduct } = useContext(ProductContext);
  const { getMessage } = useMessageSource();

  const messagePrefix = selectedProduct.hasFeature(
    "INSURANCE_PLUS_OPTIONAL_SWISSCARD",
  )
    ? "InsurancePlusOptional"
    : "InsurancePlusIncluded";

  return (
    <ScdAccordion>
      <ScdAccordionSummary>
        <Typography variant="body2">
          {getMessage("InsurancePlusOptional.include.rates.swisscard.title")}
        </Typography>
      </ScdAccordionSummary>
      <ScdAccordionDetails>
        <Typography variant="body2">
          {getMessage(`${messagePrefix}.include.rates.swisscard.text`)}
        </Typography>
      </ScdAccordionDetails>
    </ScdAccordion>
  );
}
